import React, { useEffect, useState } from 'react';
import { Modal, Form, Select, message } from 'antd';
import { bindCustomerDevice, bindProviderDevice } from '@/api/customer';
import { getCustomerUsers, getProviderUsers } from '@/api/workorder';
import { getDevice } from '@/api';
import { useRequest } from 'ahooks';

interface BindModalProps {
  open: boolean;
  type: 'customer' | 'provider';
  onClose: () => void;
  onSuccess: () => void;
}

const BindModal: React.FC<BindModalProps> = ({ open, type, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const { data: deviceData } = useRequest(getDevice, { defaultParams: [{ isAll: true }] });
  const { data: customerData, refresh: refreshCustomers } = useRequest(getCustomerUsers, { manual: true });
  const { data: providerData, refresh: refreshProviders } = useRequest(getProviderUsers, { manual: true });

  useEffect(() => {
    if (open) {
      form.resetFields();
      if (type === 'customer') {
        refreshCustomers();
      } else {
        refreshProviders();
      }
    }
  }, [open, type, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      let resp;
      if (type === 'customer') {
        resp = await bindCustomerDevice({
          customerId: values.userId,
          deviceId: values.deviceId,
        });
      } else {
        resp = await bindProviderDevice({
          providerId: values.userId,
          deviceId: values.deviceId,
          serviceType: values.serviceType,
        });
      }
      if (resp.success) {
        messageApi.success('绑定成功');
        onSuccess();
      } else {
        messageApi.error(resp.errorMsg || '绑定失败');
      }
    } catch {}
  };

  const userList = type === 'customer'
    ? (customerData?.result || []).map((c: any) => ({ value: c.id, label: c.nickName || c.username }))
    : (providerData?.result || []).map((p: any) => ({ value: p.id, label: p.nickName || p.username }));

  return (
    <>
      {contextHolder}
      <Modal
        title={type === 'customer' ? '绑定客户设备' : '绑定服务商设备'}
        open={open}
        onOk={handleOk}
        onCancel={onClose}
        okText="确定"
        cancelText="取消"
        maskClosable={false}
        destroyOnHidden
      >
        <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
          <Form.Item
            label={type === 'customer' ? '客户' : '服务商'}
            name="userId"
            rules={[{ required: true, message: type === 'customer' ? '请选择客户' : '请选择服务商' }]}
          >
            <Select
              placeholder={type === 'customer' ? '请选择客户' : '请选择服务商'}
              options={userList}
              showSearch
              optionFilterProp="label"
            />
          </Form.Item>
          <Form.Item label="设备" name="deviceId" rules={[{ required: true, message: '请选择设备' }]}>
            <Select
              options={deviceData?.result?.list || []}
              allowClear
              showSearch
              optionFilterProp="name"
              placeholder="请选择设备"
              fieldNames={{ label: 'name', value: 'id' }}
            />
          </Form.Item>
          {type === 'provider' && (
            <Form.Item label="服务类型" name="serviceType">
              <Select
                placeholder="请选择服务类型"
                allowClear
                options={[
                  { value: 'install', label: '安装' },
                  { value: 'maintain', label: '维护' },
                  { value: 'repair', label: '维修' },
                ]}
              />
            </Form.Item>
          )}
        </Form>
      </Modal>
    </>
  );
};

export default BindModal;
